import Clarity from "@microsoft/clarity";
import EventBus from "@packages/event-bus/index";
import { CLARITY_PROJECT_ID } from "../../clarity/constants";
export default {
    state: {
        admin: null,
        user: null,
        token: null,
        parceiro: false,
        locale: null,
        filters: {
            search: "",
            userType: null,
            date: {
                min: null,
                max: null,
            },
        },
        isClarityInitialized: false,
    },

    mutations: {
        SET_ADMIN(state, admin) {
            state.admin = admin;
        },

        SET_USER(state, user) {           
            state.user = user;
            EventBus.$emit("SET-AVATAR");            
            if (!state.admin && user) {
                if (!state.isClarityInitialized) {                
                    Clarity.init(CLARITY_PROJECT_ID);
                    state.isClarityInitialized = true;
                }
                Clarity.identify(user.accountId.toString(), undefined, undefined, user.nome);
            }
        },
        SET_AVATAR(state, avatar) {
            state.user.avatar = avatar;
        },
        SET_LOGO(state, logo) {
            state.user.logo = logo;
        },

        SET_USERS_LIST(state, list) {
            state.list = list;
        },
        SET_PARCEIRO(state, param) {
            state.parceiro = param;
        },
        SET_LOGIN_AS(state, param) {
            state.loginAs = param;
        },
        SET_TOKEN(state, param) {
            state.token = param;
        },
        SET_LOCALE(state, param) {
            state.locale = param;
        },

        USERS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        LOGOUT(state) {
            state.admin = null;
            state.user = null;
        },
    },

    getters: {
        userRoles(state) {
            const user = state.user;

            if (!user || !user.roles) return [];

            return user.roles.split(",");
        },

        locale(state) {
            const locale = state.locale;
            return locale;
        },
    },
};
